import React from 'react'
import { useAccordionStateHelper } from 'features/Booking/model/hooks/useAccordionStateHelper'
import { LoaderPreview } from 'features/OrderPreview/ui'
import { RefundOrder } from 'features/Booking/ui/components/Refund/RefundOrder'
import { FormTabs } from 'features/Booking/ui/components/Forms/FormTabs'
import { History } from 'features/Booking/ui/components/History/History'
import { Header } from './components'
import { BookingSidebarContainer } from './styles'
import { useBookingSidebarController } from '../model/hooks'
import { Footer } from './components/Footer'

export const BookingSidebar = () => {
    const {
        isHistory,
        isOrderExist,
        isCompany,
        isEditStateInitialising,
        onGoToPaymentRedirectUrl,
        activeTabIndex,
        disabledTabIndex,
        isOpen,
        isPreview,
        isEdit,
        isRefund,
        isPaid,
        isPastBooking,
        goFromPreviewToEdit,
        onChangeTab,
        handleCloseSidebar,
        handleForceCloseSidebar,
        onDeleteOrder,
        onRemoveBooking,
        onGoRefund,
        goToHistory,
    } = useBookingSidebarController()
    const { AccordionState, onGoToPayment } = useAccordionStateHelper(isPreview)

    return (
        <BookingSidebarContainer isexpanded={isOpen}>
            <div
                className='sibedar-top-row'
                style={{
                    height: '100%',
                    overflowY: 'auto',
                    overflowX: 'hidden',
                }}
            >
                <Header
                    isHistory={isHistory}
                    isOrderExist={isOrderExist}
                    onGoToPayment={onGoToPayment}
                    onGoToPaymentRedirectUrl={onGoToPaymentRedirectUrl}
                    onRemoveBooking={onRemoveBooking}
                    isPreview={isPreview}
                    goFromPreviewToEdit={goFromPreviewToEdit}
                    onDeleteOrder={onDeleteOrder}
                    handleCloseSidebar={handleCloseSidebar}
                    handleForceCloseSidebar={handleForceCloseSidebar}
                    onGoRefund={onGoRefund}
                    goToHistory={goToHistory}
                    isPaid={isPaid}
                    isPastBooking={isPastBooking}
                />
                <div className='line'></div>
                {isEditStateInitialising && isCompany === null ? (
                    <LoaderPreview />
                ) : (
                    <>
                        <div style={{ flex: 1, width: '100%' }}>
                            {isHistory ? (
                                <History />
                            ) : isRefund ? (
                                <RefundOrder />
                            ) : (
                                <FormTabs
                                    activeTabIndex={activeTabIndex}
                                    disabledTabIndex={disabledTabIndex}
                                    onChangeTab={onChangeTab}
                                    AccordionState={AccordionState}
                                    isEdit={isEdit}
                                    isPreview={isPreview}
                                />
                            )}
                        </div>
                        {!isHistory && <Footer />}
                    </>
                )}
            </div>
        </BookingSidebarContainer>
    )
}
